import { NavigateProvider, useNavigateContext } from '@medely/ui-kit';
import React, { type PropsWithChildren } from 'react';
import { proRoutes, type ProRoutes } from '@mp/routes';
import auth from '@mp/utils/firebase/firebase.web';
import { multiFactor } from 'firebase/auth';
import { FirebaseError } from 'firebase/app';

export function ProNavigateProvider(props: PropsWithChildren) {
  return <NavigateProvider routes={proRoutes}>{props.children}</NavigateProvider>;
}

export function useProNavigate() {
  return useNavigateContext<ProRoutes>();
}

export function useProNavigateWithMfaRequirement() {
  const { navigate } = useProNavigate();
  // const { value: isTwoFactorEnabled } = useGate(gateNames.twoFactorAuth);
  //PRO-4311: auto-enabling feature, we're getting "uninitialized" for a few users
  //for more info: https://console.statsig.com/77BnvelPYx2hauQxOLDNZI/gates/fg_mfa/diagnostics
  const isTwoFactorEnabled = true;

  const firebaseUser = auth.currentUser;
  const mfaInfo = firebaseUser ? multiFactor(firebaseUser) : null;
  const isMfaEnrolled = mfaInfo ? mfaInfo.enrolledFactors.length > 0 : false;

  const navigateWithMfaRequirement = <K extends keyof ProRoutes>(
    route: K,
    params?: ProRoutes[K],
    firebaseError?: FirebaseError,
  ) => {
    const firebaseErrorObject = firebaseError
      ? { firebaseError: JSON.stringify(firebaseError) }
      : {};
    if (isMfaEnrolled || !isTwoFactorEnabled) {
      navigate(route as any, params as any);
    } else {
      if (firebaseUser && !firebaseUser.emailVerified) {
        navigate('MfaIdentityVerificationScreen', {
          forward: JSON.stringify({ forwardTo: route, forwardParams: params }) as any,
          ...firebaseErrorObject,
        });
      } else {
        navigate('MfaSmsCodeEntryScreen', {
          forward: JSON.stringify({ forwardTo: route, forwardParams: params }) as any,
          ...firebaseErrorObject,
        });
      }
    }
  };

  return {
    navigateWithMfaRequirement,
  };
}
